// Блок «Данные Garmin» в карточке тренировки: пульс, калории, нагрузка и зоны привязанной
// активности; отвязать или выбрать другую активность того же дня.

import { useState } from 'react'
import { Link } from 'react-router-dom'

import { Button, Card, ErrorText, Select, useToast } from '@/components/ui'
import { formatTime } from '@/lib/format'

import { activitiesApi, itemsOf, useActivities, useLinkActivity } from './api'
import { activityTitle } from './logic'
import { ActivityStats, ZoneBars } from './parts'

export function SessionActivityBlock({ sessionId, day }: { sessionId: string; day: string }) {
  const linked = useActivities({ session_id: sessionId })
  const sameDay = useActivities({ start: day, end: day })
  const link = useLinkActivity()
  const toast = useToast()
  const [choice, setChoice] = useState('')

  const activities = itemsOf(linked.data)
  const others = itemsOf(sameDay.data).filter((a) => a.workout_session_id !== sessionId)
  if (linked.isPending || (activities.length === 0 && others.length === 0)) return null

  const save = (id: string, target: string | null, message: string) =>
    link.mutate(
      { id, sessionId: target },
      {
        onSuccess: () => {
          setChoice('')
          toast.show({ message })
        },
      },
    )

  return (
    <Card title="Данные Garmin" className="mt-4">
      {activities.length === 0 ? (
        <p className="text-sm text-muted">Активность Garmin к этой тренировке не привязана.</p>
      ) : (
        <div className="space-y-5">
          {activities.map((a) => (
            <div key={a.id} className="space-y-3">
              <div className="flex flex-wrap items-center gap-3 text-sm">
                <Link to={`/activities/${a.id}`} className="font-medium text-accent hover:underline">
                  {activityTitle(a)} · {formatTime(a.start_at)}
                </Link>
                <Button size="sm" variant="ghost" onClick={() => save(a.id, null, 'Активность отвязана')}>
                  Отвязать
                </Button>
              </div>
              <ActivityStats activity={a} compact />
              <ZoneBars zones={a.hr_zones_s} />
            </div>
          ))}
        </div>
      )}
      {others.length > 0 ? (
        <div className="mt-4 flex flex-wrap items-end gap-2 border-t border-border pt-4">
          <Select
            label={activities.length ? 'Другая активность этого дня' : 'Привязать активность этого дня'}
            value={choice}
            placeholder="— выбери активность —"
            options={others.map((a) => ({ value: a.id, label: `${formatTime(a.start_at)} · ${activityTitle(a)}` }))}
            onChange={(e) => setChoice(e.target.value)}
            containerClassName="min-w-[16rem]"
          />
          <Button
            disabled={!choice}
            loading={link.isPending}
            onClick={async () => {
              // «Другая активность»: прежнюю отвязываем, новую привязываем.
              await Promise.all(activities.map((a) => activitiesApi.link(a.id, null)))
              save(choice, sessionId, 'Активность привязана к тренировке')
            }}
          >
            Привязать
          </Button>
        </div>
      ) : null}
      <ErrorText error={link.error} className="mt-2" />
    </Card>
  )
}
